import { render, staticRenderFns } from "./NbSearchAheadInput.vue?vue&type=template&id=60555d1c&"
import script from "./NbSearchAheadInput.vue?vue&type=script&lang=js&"
export * from "./NbSearchAheadInput.vue?vue&type=script&lang=js&"
import style0 from "./NbSearchAheadInput.vue?vue&type=style&index=0&id=60555d1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports